import { NgModule, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[shcScrollbarTheme]'
})
export class ScrollbarThemeDirective {

  constructor(el: ElementRef) {
    const stylesheet = `
      ::-webkit-scrollbar {
          width: 0;
          height: 0;
          display: none;
      }
      ::-webkit-scrollbar-track {
          box-shadow: none;
          border-radius: 0x;
          background: transparent;
      }
      ::-webkit-scrollbar-thumb {
          background: transparent;
          border-radius: 0px;
      }
      ::-webkit-scrollbar-thumb:hover {
          background: transparent;
      }
    `;

    const styleElmt = el.nativeElement.shadowRoot.querySelector('style');

    if (styleElmt) {
      styleElmt.append(stylesheet);
    } else {
      const barStyle = document.createElement('style');
      barStyle.append(stylesheet);
      el.nativeElement.shadowRoot.appendChild(barStyle);
    }

  }

}
